// extracted by mini-css-extract-plugin
export default {"faqContainer":"faqStyles_faqContainer__pf6Ed","questionDiv":"faqStyles_questionDiv__u9KwM"};